import styled, { css } from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import BodyText from "core/BodyText";
import { easingSeconds } from "core/animation";

// styled-components
export const ThankYouBubbleStyled = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transition: all ${easingSeconds} ease;

    transform: translate(-50%, -140%);
    opacity: 0;

    ${({ isVisible }) => {
        if (isVisible) {
            return css`
                transform: translate(-50%, -180%);
                opacity: 1;
            `;
        }
    }};
`;

export const Pointer = styled.div`
    height: ${convertPxToRem({ px: 7 })};
    width: ${convertPxToRem({ px: 7 })};
    background: ${colors.primary.snow};
    margin: 0 auto;
    transform: rotate(45deg);
    margin-top: -3px;
    position: relative;
`;

export const Bubble = styled(BodyText).attrs({
    size: "sm",
    type: "div",
    copyColor: colors.secondary.orca
})`
    background-color: ${colors.primary.snow};
    padding: ${convertPxToRem({ px: 6 })};
    border-radius: ${convertPxToRem({ px: 2 })};
`;
